var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-w-100 ui-my-4 separator"})
}
var staticRenderFns = []

export { render, staticRenderFns }